module.exports = __webpack_public_path__ + "static/media/1.2fd13c5f.png";